import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["content", "customer", "background", "shadow", "color", "padding", "iconProps", "footerWrapperRow", "servicePackageIcon", "className"],
  _excluded2 = ["size", "content", "customer", "imageSrc", "shadow", "iconProps", "servicePackageIcon", "className"],
  _excluded3 = ["type", "size", "imageSrc", "background", "color", "padding", "footerWrapperRow", "servicePackage", "className"],
  _excluded4 = ["type", "shortFirst", "fullWidthThreshold", "wrapperCol", "wrapperRow", "className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classNames from 'classnames';
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuImage from "../DixuImage/DixuImage";
import DixuText from "../DixuText/DixuText";
import QuotationMarks from "../../public/icons/quotation_marks.svg";
import React from 'react';
import { SERVICE_PACKAGE } from "../../utils/DixuConstants";
import DixuAndMeIcon from "../../public/images/dixu_and_me.svg";
import DixuAndRealtorIcon from "../../public/images/dixu_and_realtor.svg";
import { toRem } from "../../utils/Utils";
const DixuCustomerExperienceCardSolid = _ref => {
  let {
      content,
      customer,
      background,
      shadow,
      color,
      padding,
      iconProps,
      footerWrapperRow,
      servicePackageIcon,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-customer-experience-card-solid', {
    [`bg-${background}`]: background,
    [`box-shadow-${shadow}`]: shadow,
    [`color-${color}`]: color,
    [`p-${padding}`]: padding
  }, className);
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classes
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "dixu-customer-experience-card-solid__content"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 16]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    fill: color
  }, /*#__PURE__*/React.createElement(QuotationMarks, {
    style: {
      height: toRem(32)
    }
  }))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "3"
  }, content)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DixuRow, _objectSpread({
    justify: 'space-between',
    align: 'middle',
    gutter: 12,
    wrap: false
  }, footerWrapperRow), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    weight: "bold"
  }, customer)), servicePackageIcon && /*#__PURE__*/React.createElement(DixuCol, null, servicePackageIcon))));
};
DixuCustomerExperienceCardSolid.defaultProps = {
  background: '2-1',
  color: '2-8',
  padding: '32'
};
const DixuCustomerExperienceCardGlass = _ref2 => {
  let {
      size,
      content,
      customer,
      imageSrc,
      shadow,
      iconProps,
      servicePackageIcon,
      className
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-customer-experience-card-glass', 'border-radius-lg', {
    [`dixu-customer-experience-card--size-${size}`]: size
  }, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(DixuImage, {
    src: imageSrc,
    aspectRatio: false,
    className: "dixu-customer-experience-card-glass__image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "dixu-customer-experience-card-glass__image-overlay"
  }), /*#__PURE__*/React.createElement(DixuRow, {
    justify: "space-between",
    gutter: [0, 24],
    direction: "column",
    wrap: false,
    className: "dixu-customer-experience-card-glass__content"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24,
    flex: "0 1 auto"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 24]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    fill: "2-9"
  }, /*#__PURE__*/React.createElement(QuotationMarks, {
    style: {
      height: toRem(32)
    }
  }))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-9",
    weight: "medium",
    shadow: "2"
  }, content)))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24,
    flex: "0 1 auto"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "space-between",
    align: "middle",
    gutter: 32,
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    font: "4",
    color: "2-9",
    weight: "bold"
  }, customer)), servicePackageIcon && /*#__PURE__*/React.createElement(DixuCol, null, servicePackageIcon)))));
};
DixuCustomerExperienceCardGlass.defaultProps = {};
const DixuCustomerExperienceCard = _ref3 => {
  let {
      type,
      size,
      imageSrc,
      background,
      color,
      padding,
      footerWrapperRow,
      servicePackage,
      className
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  const classes = classNames('dixu-customer-experience-card', className);
  const servicePackageIcon = {
    [SERVICE_PACKAGE.DIXU_EASY]: /*#__PURE__*/React.createElement(DixuAndMeIcon, {
      style: {
        width: toRem(78),
        height: toRem(48)
      }
    }),
    [SERVICE_PACKAGE.DIXU_PLUS]: /*#__PURE__*/React.createElement(DixuAndRealtorIcon, {
      style: {
        width: toRem(78),
        height: toRem(48)
      }
    })
  }[servicePackage];
  if (type === 'solid') {
    return /*#__PURE__*/React.createElement(DixuCustomerExperienceCardSolid, _objectSpread({
      className: classes,
      background,
      color,
      padding,
      footerWrapperRow,
      servicePackageIcon
    }, rest));
  }
  if (type === 'glass') {
    return /*#__PURE__*/React.createElement(DixuCustomerExperienceCardGlass, _objectSpread({
      className: classes,
      imageSrc,
      size,
      servicePackageIcon
    }, rest));
  }
  return null;
};
DixuCustomerExperienceCard.defaultProps = {
  type: 'solid',
  servicePackage: undefined,
  size: undefined,
  imageSrc: undefined,
  shadow: '3',
  background: undefined,
  color: undefined,
  padding: undefined,
  iconProps: undefined,
  footerWrapperRow: undefined
};
const DixuCustomerExperienceCardGroup = _ref4 => {
  let {
      type,
      shortFirst,
      fullWidthThreshold,
      wrapperCol,
      wrapperRow,
      className,
      children
    } = _ref4,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  const classes = classNames('dixu-customer-experience-card-group', className);
  const mappedChildren = (() => {
    if (type === 'adjust') {
      return React.Children.map((() => {
        if (shortFirst) {
          return [...(children || [])].sort((a, b) => {
            const {
              content: contentA
            } = a?.props || {};
            const {
              content: contentB
            } = b?.props || {};
            if (!contentA || !contentB) {
              return 0;
            }
            return contentA.length - contentB.length;
          });
        }
        return children;
      })(), (child, index) => {
        const {
          props
        } = child;
        const content = props?.content || '';
        const halfWidth = content.length < fullWidthThreshold;
        return /*#__PURE__*/React.createElement(DixuCol, _objectSpread({
          key: index.toString(36),
          type: 'flex',
          className: classNames('dixu-customer-experience-card-group__card-wrapper', {
            'dixu-customer-experience-card-group__card-wrapper--half-width': halfWidth
          })
        }, wrapperCol), /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, props), {}, {
          size: halfWidth ? undefined : 'lg'
        })));
      });
    }
    return React.Children.map(children, (child, index) => {
      return /*#__PURE__*/React.createElement(DixuCol, _objectSpread({
        key: index.toString(36),
        xs: 24,
        xl: 8,
        type: 'flex'
      }, wrapperCol), child);
    });
  })();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(DixuRow, _objectSpread({
    gutter: [32, 32]
  }, wrapperRow), mappedChildren));
};
DixuCustomerExperienceCardGroup.defaultProps = {
  type: 'default',
  shortFirst: false,
  fullWidthThreshold: 320,
  wrapperRow: undefined,
  wrapperCol: undefined
};
DixuCustomerExperienceCard.Group = DixuCustomerExperienceCardGroup;
export default DixuCustomerExperienceCard;